import {
  RuntimeAction,
  SPI,
  ActionWidget,
  ActionWidgetProps,
  TableWidget,
  Widget,
  ModelFieldType
} from '@kunlun/dependencies';
import XLSX from 'xlsx';
import FileSaver from 'file-saver';

@SPI.ClassFactory(ActionWidget.Token({ name: ['ExportDirect', 'DeliAriesActivityItemTplDetailExport'] }))
export class ExportDirect extends ActionWidget {
  public initialize(props: ActionWidgetProps<RuntimeAction>) {
    super.initialize(props);

    return this;
  }

  protected async clickAction(...args: unknown[]) {
    const table = Widget.select(this.rootRuntimeContext.handle)!
      .getChildren()
      // @ts-ignore
      .find((i) => i.component.name === 'DefaultTable') as TableWidget;
    const columns = table.getColumnWidgets(true);

    const dataValue = table.getData()!;
    const targetData = [] as Record<string, unknown>[];
    const enumDisplayNameMaps: Record<string, Record<string, string>> = {};

    dataValue.forEach((data) => {
      const targetD = {} as Record<string, unknown>;
      columns.forEach((column) => {
        // @ts-ignore
        const { label, name, ttype, options } = column.field;
        if ((name as string).toLowerCase() !== 'id') {
          // 枚举显示displayName
          if (ttype === ModelFieldType.Enum) {
            if (!enumDisplayNameMaps[name]) {
              enumDisplayNameMaps[name] = {};
              options.forEach((opt) => {
                enumDisplayNameMaps[name][opt.name] = opt.displayName.trim();
              });
            }
            const displayName = enumDisplayNameMaps[name][data[name] as string];
            targetD[label] = displayName;
          }
          // 其他类型值
          else {
            targetD[label] = data[name];
          }
        }
      });
      targetData.push(targetD);
    });
    this.saveJsonToExcel(targetData, '导出.xlsx');
  }

  public saveJsonToExcel(data, filename) {
    const sheet = XLSX.utils.json_to_sheet(data);
    const workbook = {
      SheetNames: ['sheet1'],
      Sheets: {
        sheet1: sheet
      }
    };
    const wbout = XLSX.write(workbook, {
      bookType: 'xlsx',
      bookSST: true,
      type: 'array'
    });
    FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), filename);
  }
}
